import { Body1, Link, UIHeading2 } from '@cian/ui-kit';
import React from 'react';

import * as styles from './Contacts.css';
import { IAgentCard } from '../../types/agentCard';
import { AsideRow } from '../AsideRow';

interface IContactsProps {
  phonesNode: React.ReactNode | null;
  regionsNames: string;
  skype: IAgentCard['skype'];
  email?: string | null;
  website: IAgentCard['website'];
}

export const Contacts = ({ phonesNode, skype, email, website, regionsNames }: IContactsProps) => {
  if (!phonesNode && !website && !skype && !email && !regionsNames) {
    return null;
  }

  return (
    <div data-name="Contacts" className={styles['container']}>
      <UIHeading2>Свяжитесь с агентством</UIHeading2>
      {phonesNode && (
        <AsideRow title="Телефон" content={<div className={styles['phone-container']}>{phonesNode}</div>} />
      )}
      {website && (
        <AsideRow
          title="Сайт"
          content={
            <Link fontSize="M" href={website} target="_blank" rel="noopener noreferrer">
              {website}
            </Link>
          }
        />
      )}
      {skype && (
        <AsideRow
          title="Skype"
          content={
            <Link fontSize="M" href={`skype:${skype}`}>
              {skype}
            </Link>
          }
        />
      )}
      {email && (
        <AsideRow
          title="Email"
          content={
            <Link fontSize="M" href={`mailto:${email}`}>
              {email}
            </Link>
          }
        />
      )}
      {regionsNames && <AsideRow title="Регион работы" content={<Body1>{regionsNames}</Body1>} />}
    </div>
  );
};
